var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-group" }, [
    _c("label", [
      _vm.f.IsRequired
        ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.f.Name) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.f.Values,
            expression: "f.Values",
          },
        ],
        staticClass: "form-control",
        attrs: {
          multiple: "",
          required: _vm.f.IsRequired,
          disabled: _vm.f.IsReadonly,
        },
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.$set(
              _vm.f,
              "Values",
              $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            )
          },
        },
      },
      _vm._l(_vm.f.DefinedValues, function (dv) {
        return _c("option", { domProps: { value: dv.Value } }, [
          _vm._v(_vm._s(dv.Label)),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
    _vm._v(" "),
    _vm.f.Description
      ? _c("small", { staticClass: "form-text text-muted" }, [
          _vm._v(_vm._s(_vm.f.Description)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }